import React, { useState } from "react";
import QRGenerateButton from "./QRGenerateButton";

function SmsQR() {
  const [input, setInput] = useState("");
  const [showQR, setShowQR] = useState(false);
  const [formError, setFormError] = useState(false);
  const [smsNumber, setSmsNumber] = useState("");
  const [smsBody, setSmsBody] = useState("");

  function createSms() {
    if (smsNumber) {
      var QRsms = "sms:" + smsNumber + "?&body=" + smsBody;
      setInput(QRsms);
      showQRCode();
      setShowQR(true);
      setFormError(false);
    } else {
      setFormError(true);
      showQRCode(false);
      setShowQR(false);
    }
  }

  function showQRCode() {
    document.getElementById("qrwrap").scrollIntoView({
      behavior: "smooth",
    });
  }
  return (
    <>
      <div className="qr-form">
        <h3>SMS QR Code</h3>
        <p>
          Want to increase SMS? make it to a QR with a <i>to</i> number and an
          editable message, this gonna take out all the hassles.
        </p>
        <input
          type="text"
          value={smsNumber}
          onInput={(e) => setSmsNumber(e.target.value)}
          name="qrcode_sms_number"
          id="qrsmsnumber"
          placeholder="Enter phone number"
        />
        <textarea
          value={smsBody}
          onInput={(e) => setSmsBody(e.target.value)}
          name="qrcode_sms_body"
          id="qrsmsbody"
          placeholder="Enter message"
          maxLength={160}
        />
        {formError && (
          <div className="errorMessage">Error: Field cannot be blank!</div>
        )}
        <button
          type="button"
          className="contrast"
          onClick={() => {
            createSms();
          }}
        >
          Generate QR
        </button>
      </div>
      <QRGenerateButton
        QRType="sms"
        QRValue={input}
        showQR={showQR}
        setInput={setInput}
        setShowQR={setShowQR}
      />
    </>
  );
}

export default SmsQR;
